import React from "react";
import ReactDOM from "react-dom/client";
import AiChangeDetectionGeospatial from "./ai-change-detection-geospatial";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiChangeDetectionGeospatial />
  </React.StrictMode>,
);
